import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppApartadosComponent } from './app-apartados.component';

import { jqxTreeModule } from 'jqwidgets-ng/jqxtree';
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxDropDownListModule } from 'jqwidgets-ng/jqxdropdownlist';
import { jqxLoaderModule } from 'jqwidgets-ng/jqxloader';
import { jqxInputModule } from 'jqwidgets-ng/jqxinput';
import { FormsModule } from '@angular/forms';
import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';
import { jqxCheckBoxModule } from 'jqwidgets-ng/jqxcheckbox';
import { NzModalModule } from 'ng-zorro-antd/modal';

@NgModule({
  declarations: [AppApartadosComponent],
  imports: [
    CommonModule,
    FormsModule,
    jqxLoaderModule,
    jqxTreeModule,
    jqxButtonModule,
    jqxDropDownListModule,
    jqxInputModule,
    jqxGridModule,
    jqxCheckBoxModule,
    NzModalModule,
  ],
  exports: [AppApartadosComponent],
})
export class AppApartadosModule {}
